define('Meetanshi_Paya/js/view/payment/payment-info-logger',['jquery', 'mage/url'], function ($, url,) {
        'use strict';

        return {
            logResponseData: function (message) {
                if (typeof message === 'object' && message !== null) {
                    message = JSON.stringify(message);
                }

                $.ajax({
                    type: 'post',
                    data: {
                        form_key: $("input[name='form_key']").val(),
                        message: message
                    },
                    url: url.build("paya/checkout/log"),
                    dataType: "json"
                });
            }
        }
    }
);

